import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { Trans } from 'react-i18next'

import { ingredientGroupsQuery } from '@/api'
import NotificationBanner from '@/components/NotificationBanner/NotificationBanner'
import { Spinner } from '@/components/Spinner'
import IngredientsGroupPanel from '@/features/ingredients/IngredientIndex/IngredientsGroupPanel'
import { TabPanel } from '@/components/Tabs'
import { useSharedPersistentState } from '@/hooks/useSharedPersistentState'
import { INGREDIENTS_BANNER } from './ingredients'

type SearchParams = {
  languaLID?: string
  search?: string
  page?: string
}

export const Route = createFileRoute('/ingredients/displaynames')({
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient }, deps }) => {
    queryClient.ensureQueryData(ingredientGroupsQuery)
  },
  component: IngredientsComponent,
  pendingComponent() {
    return <Spinner />
  },
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    // validate and parse the search params into a typed state
    return {
      languaLID: search.languaLID as string,
      search: search.search as string,
      page: search.page as string,
    }
  },
})

function IngredientsComponent() {
  const { data: groups } = useSuspenseQuery(ingredientGroupsQuery)
  const [isIngredientBannerVisible, setIsIngredientBannerVisible] = useSharedPersistentState(
    INGREDIENTS_BANNER,
    true,
  )

  return (
    <>
      <TabPanel id="displaynames">
        {isIngredientBannerVisible && (
          <NotificationBanner
            style={{ marginTop: '5px' }}
            onClose={() => setIsIngredientBannerVisible(false)}>
            <Trans i18nKey="ingredient.ingredientsBanner" />
          </NotificationBanner>
        )}
        <IngredientsGroupPanel ingredientGroups={groups || []} />
      </TabPanel>
    </>
  )
}
